import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import newlogo from "../images/logoBBT.svg";
import "../commonCss/Footer.css";
import apple from "../images/IOS.svg";
import android from "../images/PlayStore.svg";
import travelPortal from "../images/travel.svg";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [popup, setPopup] = useState(null);
  const handleNewsletterSubscibe = async () => {
    // Validate email
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setPopup({
        type: "error",
        message: "Please enter a valid email address.",
      });
      setTimeout(() => setPopup(null), 3000);
      return;
    }

    try {
      // Make POST API call with email in the body
      const response = await fetch(
        `https://blueberry-travel.com/api/apiuser/SubmitSubscribe?email=${email}`,
        {
          method: "POST", // Explicit POST method
          headers: {
            // Optional: Add headers if needed (e.g., API keys)
            // 'Authorization': 'Bearer YOUR_TOKEN',
          },
        }
      );

      if (!response.ok) {
        throw new Error("Subscription failed");
      }

      // Handle success
      setPopup({ type: "success", message: "Subscribed successfully!" });
      setEmail(""); // Clear input after successful submission
    } catch (error) {
      // Handle errors
      setPopup({
        type: "error",
        message: "Subscription failed. Please try again later.",
      });
    } finally {
      setTimeout(() => setPopup(null), 3000);
    }
  };

  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="mt-2 footer-f-color">
                <a href="/">
                  <img
                    src={newlogo}
                    alt="Blueberry Travel logo"
                    className="w-40 h-auto"
                    style={{ maxWidth: "100%" }}
                  />
                </a>

                <div className="row g-2 mt-3">
                  <div className="col-8">
                    <div className="d-flex gap-3">
                      <a
                        href="https://amadeus.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LazyLoadImage
                          effect="blur"
                          src="https://blueberrywebsites.azureedge.net/bbt/icons/newAmadeus.png"
                          alt="one"
                          className="img-fluid amadeus"
                        />
                      </a>
                      <a
                        href="https://www.sabre.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LazyLoadImage
                          effect="blur"
                          src="https://blueberrywebsites.azureedge.net/bbt/icons/newSabre.png"
                          alt="one"
                          className="img-fluid sambre"
                        />
                      </a>
                    </div>
                    <div className="d-flex gap-3">
                      <a
                        href="https://www.worldtravelawards.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LazyLoadImage
                          effect="blur"
                          src="https://blueberrywebsites.azureedge.net/bbt/icons/WorldTravelAwards-Logo-02.svg"
                          alt="one"
                          className="img-fluid wroldtravel"
                        />
                      </a>
                      <a
                        href="https://www.iata.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LazyLoadImage
                          effect="blur"
                          src="https://blueberrywebsites.azureedge.net/bbt/icons/newATPI%20IATA.png"
                          alt=""
                          className="atpaiata"
                        />
                      </a>
                    </div>
                    <a
                      href="https://www.travelport.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LazyLoadImage
                        effect="blur"
                        src="https://blueberrywebsites.azureedge.net/bbt/icons/newTravelPort.png"
                        alt="one"
                        className="img-fluid travelport"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 d-flex justify-content-lg-center justify-content-md-start">
              <div className="mt-3 footer-f-color">
                <p className="mb-4 text-white">
                  {" "}
                  <strong>GET IN TOUCH</strong>{" "}
                </p>
                <address>
                  <p className="smallfontP mb-0">
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=Regal+Tower,+Business+Bay,+Dubai,+United+Arab+Emirates"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-reset"
                    >
                      The Regal Tower 1605,
                      <br />
                      Business Bay,  Dubai - UAE
                    </a>
                  </p>
                  <p className="smallfontP position-relative">
                    <a
                      href="mailto:info@blueberry-travel.com"
                      className="mb-2 position-relative"
                    >
                      info@blueberry-travel.com
                    </a>{" "}
                    <br />
                    <a
                      href="tel:+97147707355"
                      className="mt-2 position-relative"
                    >
                      +971 4 7707355
                    </a>
                  </p>
                  <a
                    href="https://blueberrywebsites.azureedge.net/bbt/images/QR.png"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Footer%20Qr%20White%20New.svg"
                      alt="QR code"
                      className="h-75 qr-img"
                      loading="lazy"
                    />
                  </a>
                  <br />
                </address>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 d-flex justify-content-lg-center justify-content-md-start">
              <div className="mt-3 footer-f-color">
                <p className="mb-4 text-white">
                  <strong> LINKS</strong>{" "}
                </p>
                <ul className="list-unstyled smallfontP">
                  <li className="mt-2">
                    <a
                      href="/web-flight-check-in"
                      className="text-decoration-none footer-f-color"
                    >
                      Flight Check-In
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="/our-story"
                      className="text-decoration-none footer-f-color"
                    >
                      Our story
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="/global-solution"
                      className="text-decoration-none footer-f-color"
                    >
                      Global Solutions
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="blog"
                      className="text-decoration-none footer-f-color"
                    >
                      Blogs
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="contact"
                      className="text-decoration-none footer-f-color"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="/corporate-travel"
                      className="text-decoration-none footer-f-color"
                    >
                      Corporate Travel Management
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="terms-and-conditions"
                      className="text-decoration-none footer-f-color"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="privacy-policy"
                      className="text-decoration-none footer-f-color"
                    >
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 d-flex justify-content-lg-center justify-content-md-start">
              <div className="mt-3 footer-f-color">
                {/* TRAVEL TECH Row */}
                <div className="tavel-tech mb-4">
                  {/* Travel APP Section */}
                  <div className="travel-app">
                    <p className="font-semibold mb-2">Travel APP</p>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.blueberrytraveler.ap"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center"
                    >
                      <button className="btn footer-button">
                        <LazyLoadImage
                          effect="blur"
                          src={android}
                          width={"24px"}
                          height={"24px"}
                          alt="Android"
                          loading="lazy"
                        />
                        {"  "} Play Store
                      </button>
                    </a>
                    <a
                      href="https://apps.apple.com/us/app/blueberry-traveller/id6670241491"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center"
                    >
                      <button className="btn footer-button">
                        <LazyLoadImage
                          effect="blur"
                          src={apple}
                          width={"24px"}
                          height={"24px"}
                          alt="iOS"
                          loading="lazy"
                        />{" "}
                        iOS
                      </button>
                    </a>
                  </div>

                  {/* BBT Portal Section */}
                  <div className="bbt-portal">
                    <p className="font-semibold mb-2">BBT Portal</p>
                    <a
                      href="https://bbtportal.blueberry-travel.com/login"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      <button className="btn footer-button">
                        <LazyLoadImage
                          effect="blur"
                          src={travelPortal}
                          width={"24px"}
                          height={"24px"}
                          alt="iOS"
                          loading="lazy"
                        />{" "}
                        Open BBT Portal
                      </button>
                    </a>
                  </div>
                </div>

                {/* SUBSCRIBE US Section */}
                <p className="mb-2 text-white">
                  <strong>SUBSCIBE US</strong>
                </p>
                <p className="smallfontP">
                  Subscribe to our newsletter to get our <br />
                  news & deals delivered to you.
                </p>

                <div className="email-join-container">
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="email-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    className="join-button"
                    onClick={handleNewsletterSubscibe}
                  >
                    JOIN
                  </button>
                  {/* Show popup here */}
                  {popup && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        backgroundColor:
                          popup.type === "success" ? "#d4edda" : "#f8d7da",
                        color: popup.type === "success" ? "#155724" : "#721c24",
                        padding: "8px 12px",
                        marginTop: "6px",
                        fontSize: "0.85rem",
                        borderRadius: "4px",
                        textAlign: "center",
                        zIndex: 99,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      {popup.message}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="fotter-black">
        <div className="footer-bottom d-flex justify-content-between align-items-center">
          <p className="all-rights">
            © 2025 Blueberry Travel All rights reserved.
          </p>

          <div className="d-flex gap-footer-img">
            <a
              href="https://www.youtube.com/@BBT_BlueberryTravel"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footYT.svg"
                alt="youtube"
                className="position-relative social-img me-1 me-md-0"
                loading="lazy"
              />
            </a>
            <a
              href="https://wa.me/919251655411"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footWA.svg"
                alt="whatsapp"
                className="position-relative social-img ps-md-2 ms-1 ms-md-0"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.facebook.com/blueberrytravel.worldwide/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footFB.svg"
                alt="facebook"
                className="position-relative social-img"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.instagram.com/blueberry.travel/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/ffotIG.svg"
                alt="instagram"
                className="position-relative social-img"
                loading="lazy"
              />
            </a>
            <a
              href="https://x.com/trvlblueberry"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footTW.svg"
                alt="twitter"
                className="position-relative twitter-img social-img ps-md-2"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
